import { render, staticRenderFns } from "./CreateCandidate.vue?vue&type=template&id=40c945b6&scoped=true"
import script from "./CreateCandidate.vue?vue&type=script&lang=js"
export * from "./CreateCandidate.vue?vue&type=script&lang=js"
import style0 from "./CreateCandidate.vue?vue&type=style&index=0&id=40c945b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c945b6",
  null
  
)

export default component.exports